<template>
  <app-layout class="mb-5">
    <template #header>
      <AppHead title="Wholesale Cart" />
      <h2 class="title d-block d-lg-none">Wholesale Cart</h2>
      
      <ShopButton classes="d-lg-flex d-none" title="Wholesale Cart" :link="back_to_shop_route || route('mtd.wholesale')" />
      <flash-messages />
    </template>

    <div v-if="cart_item_future_has_passed" class="mt-3">
      <p class="alert alert-info">
        We have removed some of your future delivered items because delivery date has passed.
      </p>
    </div>

    <CartItems 
      :cart_items="cart_items" 
      :users="users"
      :total="total"
      :isWholesale="true"
      :futureSubtotal="futureSubtotal"
      :backorderSubtotal="backorderSubtotal"
    >
      <div class="mt-3 d-none d-lg-block">
        <jet-button btnStyle="success" icon="fas fa-shopping-cart" class="btn-lg px-5" :goesTo="route('mtd.wholesale.checkout')" v-if="type == 2">Checkout</jet-button>


        <card class="mb-3 mt-3" bodyClasses="p-0" title="Suggested for You" v-if="suggestions.length > 1">
          <template v-for="(product, index) in suggestions" :key="product.id">
            <div v-if="index > 0" class="line"></div>
            <ProductAdd :product="product" suggested_type="cart"/>
          </template>
        </card>
      </div>
    </CartItems>

    <div class="cart-bottom-bar d-block d-lg-none">
      <ShopButton :link="route('mtd.wholesale')">
        <inertia-link class="btn btn-success ml-2" :href="route('mtd.wholesale.checkout')" v-if="type == 2">Checkout</inertia-link>
      </ShopButton>
    </div>
  </app-layout>
</template>

<script>
  import AppLayout from '@/Layouts/AppLayout'
  import ShopButton from '@/Shared/ShopButton'
  import CartItems from '@/Components/Shop/CartItems'
  import ProductAdd from '@/Components/Shop/ProductAdd'

  export default {
    components: {
      AppLayout,
      ShopButton,
      CartItems,
      ProductAdd,
    },
    props: {
      cart_item_future_has_passed: Boolean,
      back_to_shop_route: String,
      cart_items: Array,
      total: Number,
      users: Array,
      type: Number,
      suggestions: Array
    },
    data() {
      return {
        user_id: null,
        selectedUser: null,
      }
    },
    methods: {

    }
  }
</script>

<style>
div.line {
  border-bottom: 1px #f0f0f0 solid;
}
</style>
